import classNames from 'classnames';

import NavigationBar, { propTypes } from '~/components/NavigationBar';

import style from './LootPacksNavigationBar.module.scss';

const LootPacksNavigationBar = ({ className, ...props }) => (
  <NavigationBar
    {...props}
    buttonsClassname={style.buttons}
    className={classNames(className, style.navigationBar)}
    shareButtonClassName={style.shareButton}
  />
);

LootPacksNavigationBar.propTypes = propTypes;

export default LootPacksNavigationBar;
